import { Box, Button, Menu, MenuItem, SxProps, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";

export interface ContextMenuOptions {
    label: React.ReactNode;
    click?: () => void;
    close?: boolean;
    menuItem?: boolean;
}

export interface ContextMenuProps {
    label?: React.ReactNode;
    title?: React.ReactNode;
    options?: ContextMenuOptions[];
    sx?: SxProps;
}

export function ContextMenu({ label, title, options, sx }: ContextMenuProps) {
    if (!options || options.length == 0) {
        return <></>;
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleOption = (option: ContextMenuOptions) => () => {
        if (option.click) {
            option.click();
        }
        if (option.close != false) {
            handleClose();
        }
    };

    const button =
        <Button
            sx={{ p: "6px 4px 6px 0px", minWidth: "34px", textTransform: "none", ...sx }}
            key="basic"
            color="inherit"
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}>
            {label || <MenuIcon />}
        </Button>;

    const elTitle = title
        ? <Box sx={{ bgcolor: "primary.main", color: "white" }}>
            <Typography key="menu-title" variant="h6" component="div" sx={{ textAlign: "center", ml: 2, mr: 2, p: 1 }}>
                {title}
            </Typography>
        </Box>
        : undefined;

    const key = `context-menu-${title}`;
    return (
        <Box id={key} key={key}>
            {button}
            <Menu key="menu" id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{ "aria-labelledby": "basic-button", "disablePadding": true }} >
                {elTitle}
                {options?.map((option, index) => (
                    option.menuItem == false
                        ? <Box key={index}>{option.label}</Box>
                        : <MenuItem key={index} onClick={handleOption(option)}>{option.label}</MenuItem>
                ))}
            </Menu>
        </Box>
    );
}
